import React from "react";
import { createRoot } from "react-dom/client";
import Root from "./components/Calendar/Root";
import * as Sentry from "@sentry/react";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import { ThemeProvider, createTheme } from "@mui/material/styles";
const container = document.getElementById("root");
const root = createRoot(container);
// Sentry.init({
//     dsn: "https://1758110291c1d76fbf83e37d019b078f@o294580.ingest.us.sentry.io/4506098071764992",
//     // integrations: [new Sentry.Integrations.Breadcrumbs({ console: false })],
//     integrations: [new Sentry.BrowserTracing()],

//     tunnel: "https://baza.taniec-nowoczesny.pl/tunnel",

//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 0.5,
  
//     // Capture Replay for 10% of all sessions,
//     // plus for 100% of sessions with an error
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 0.5,
// });
const darkTheme = createTheme({
    palette: {
        mode: window.APP_PROPS.itemOptions.color,
    },
});
// console.log(window.APP_PROPS);
root.render(
    <React.Fragment>
        <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <Container maxWidth="lg">
                {/* <Sentry.ErrorBoundary fallback={<div className="alert alert-danger">Wystąpił błąd - prosimy o kontakt z administratorem.</div>}> */}
                    <Root {...window.APP_PROPS} />
                {/* </Sentry.ErrorBoundary> */}
            </Container>
        </ThemeProvider>
    </React.Fragment>
);
